/*
 * @Author: Ryan
 * @Date: 2026-02-04
 * @Description: SEO sections entry file for face-swap page
 */
import React from 'react';

import ComparisonSection from './ComparisonSection';
import CTASection from './CTASection';
import ExploreToolsSection from './ExploreToolsSection';
import FAQSection from './FAQSection';
import FeaturesSection from './FeaturesSection';
import HowToUseSection from './HowToUseSection';
import PossibilitiesSection from './PossibilitiesSection';
import TestimonialsSection from './TestimonialsSection';
import UseCasesSection from './UseCasesSection';
import WhyChooseSection from './WhyChooseSection';

const SEOSections: React.FC = () => {
  return (
    <>
      <UseCasesSection />
      <HowToUseSection />
      <FeaturesSection />
      <PossibilitiesSection />
      <WhyChooseSection />
      <ComparisonSection />
      <TestimonialsSection />
      <ExploreToolsSection />
      <FAQSection />
      <CTASection />
    </>
  );
};

export default SEOSections;

export {
  ComparisonSection,
  CTASection,
  ExploreToolsSection,
  FAQSection,
  FeaturesSection,
  HowToUseSection,
  PossibilitiesSection,
  TestimonialsSection,
  UseCasesSection,
  WhyChooseSection,
};
export { default as FaceSwapShowcase } from './FaceSwapShowcase';
export { default as StartButton } from './StartButton';
